<script lang="ts">
    import LazyIcon from '$lib/components/LazyIcon/LazyIcon.svelte';
    import AnimatedLosButton from '$lib/components/Button/AnimatedLosButton.svelte';
    import type { TMarket } from '$lib/services/market/types';
    import { MARKET_SLUGS } from '$lib/services/market/slugs';
    import type { TNavItem } from './types';

    export let isTopBar = true;
    export let item: TNavItem;
    export let market: TMarket;

    const { href, testid, icon, text } = item;

    const id = isTopBar ? 'login' : 'login-bottom';
</script>

<a {href} data-testid={testid}>
    <AnimatedLosButton {id} wide={market.slug === MARKET_SLUGS.SV}>
        <span class="flex flex-nowrap items-center justify-center gap-3xs">
            {#if icon}
                <span
                    class="inline-block h-[28px] w-[28px] flex-shrink-0 desktop-l:h-lg desktop-l:w-lg"
                >
                    <LazyIcon {icon} />
                </span>
            {/if}
            <span
                class="inline-block flex-shrink-0 basis-[fit-content] text-nowrap text-xs tablet:text-base"
            >
                {text}
            </span>
        </span>
    </AnimatedLosButton>
</a>
